const SIZE_CLASSES = {
  sm: { container: 'bg-secondary gap-0.5 rounded-lg p-0.5', button: 'rounded-md px-2 py-0.5 text-xs' },
  md: { container: 'bg-input gap-0.5 rounded-lg p-0.5', button: 'rounded-md px-3 py-1 text-sm' },
};

interface AudioTypeSelectorProps<T extends string> {
  value: T;
  onChange: (type: T) => void;
  options: { value: T; label: string }[];
  size?: 'sm' | 'md';
}

export function AudioTypeSelector<T extends string>({
  value,
  onChange,
  options,
  size = 'sm',
}: AudioTypeSelectorProps<T>) {
  const classes = SIZE_CLASSES[size];

  return (
    <div className={`flex w-fit ${classes.container}`}>
      {options.map((option) => (
        <button
          type="button"
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`font-medium transition-colors ${classes.button} ${
            value === option.value
              ? 'text-foreground bg-white shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          } focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none`}
          aria-pressed={value === option.value}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
